import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ApprocheSection from "./components/ApprocheSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <ApprocheSection />
      <CTASection />
      <Footer />
    </main>
  );
}
